import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.colors.white,
    borderRadius: '4px',
    outline: 'none',
    '&:focus': {
      outline: 'none',
    },
    minWidth: 200,
    padding: 32,
  },
  hidden: {
    display: 'none',
  },
  cloaseButton: {
    padding: 0,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Modal/useStyles.js